import React, { Component } from 'react';

import Avatar from '@atlaskit/avatar';
import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { StorageOfUniqueServices } from '@qality/common-service';

import './_test-execution-history-header.scss';

type Props = {
  testCaseKey: string;
  issueKey: string;
  testCaseIssueTypeIcon: string;
  issueTypeIcon: string;
};

type State = {
  issueUrl: string;
  testCaseUrl: string;
};

export default class TestExecutionHistoryHeader extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      issueUrl: '',
      testCaseUrl: '',
    };
  }

  async componentDidMount(): Promise<void> {
    const issueUrl = await StorageOfUniqueServices.get(
      'URLService'
    ).getBrowseIssueUrl(this.props.issueKey);
    const testCaseUrl = await StorageOfUniqueServices.get(
      'URLService'
    ).getBrowseIssueUrl(this.props.testCaseKey);
    this.setState({
      issueUrl,
      testCaseUrl,
    });
  }

  render(): React.ReactNode {
    if (this.state.testCaseUrl) {
      return (
        <div>
          <div className='test_execution_history_issue_name'>
            <Breadcrumbs>
              {this.props.issueKey !== this.props.testCaseKey && (
                <BreadcrumbsItem
                  onClick={() => {
                    StorageOfUniqueServices.get('AP').navigator.go('site', {
                      absoluteUrl: this.state.issueUrl,
                    });
                  }}
                  text={'Back to issue ' + this.props.issueKey}
                  iconBefore={
                    <Avatar
                      size='xsmall'
                      appearance='square'
                      borderColor='none'
                      src={this.props.issueTypeIcon}
                    />
                  }
                />
              )}
              <BreadcrumbsItem
                onClick={() => {
                  StorageOfUniqueServices.get('AP').navigator.go('site', {
                    absoluteUrl: this.state.testCaseUrl,
                  });
                }}
                text={'Back to test case ' + this.props.testCaseKey}
                iconBefore={
                  <Avatar
                    size='xsmall'
                    appearance='square'
                    borderColor='none'
                    src={this.props.testCaseIssueTypeIcon}
                  />
                }
              />
            </Breadcrumbs>
          </div>
          <div className='test_execution_history_name'>
            Test Case Execution History
          </div>
        </div>
      );
    }
    return null;
  }
}
